import r from"../colors/index.js";var o={errorIconColor:r.red[500]};export{o as default};
